import { Injectable } from '@angular/core';
import { CrmEndpoint, CrmEndpointDecorator } from 'common-module/endpoint';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  @CrmEndpointDecorator({
    configName: 'crm',
    endpointName: 'products-export'
  })
  private endpoint!: CrmEndpoint<any>;

  public exportProducts(productIds: string[], params?: any) {
    return this.endpoint.create(
      {
        products: productIds.join(',')
      },
      {
        params,
        responseType: 'blob'
      }
    );
  }
}
